import { TextProps } from "@mantine/core"
import { RiskScore } from "@tfg/db"
import { Missing, TextCell } from "@tfg/ui"
import { useTranslation } from "react-i18next"

interface Props extends TextProps {
  risk: RiskScore
}

export const RiskScoreDisplay = ({ risk, ...rest }: Props) => {
  const { t } = useTranslation(["suppliers"])

  switch (risk) {
    case "LOW":
      return (
        <TextCell
          value={t("risk.low")}
          fw={700}
          c="var(--mantine-color-success)"
          {...rest}
        />
      )
    case "MEDIUM":
      return (
        <TextCell
          value={t("risk.medium")}
          fw={700}
          c="var(--tag-color-info)"
          {...rest}
        />
      )
    case "HIGH":
      return (
        <TextCell
          value={t("risk.high")}
          fw={700}
          c="var(--mantine-color-error)"
          {...rest}
        />
      )
    default:
      return <Missing />
  }
}
